import React from 'react';
import _get from 'lodash/get';
import { Typography, makeStyles } from '@material-ui/core';
import { getImageFile, replacePlaceholders } from 'utils/stringUtils';
import { sharedStyles } from 'containers/Series/components/seriesSharedStyles';
import Badge from 'components/Badge';

const useStyles = makeStyles(theme => ({
  ...sharedStyles(theme),
  divider: {
    borderRight: '1px solid #C0BFBF',
    margin: '0 15px',
    height: 12,
  },
  container: {
    display: 'flex',
    paddingBottom: props => props.inSidebar && 20,
    borderBottom: props => props.inSidebar && '1px solid #E0E0E0',
  },
  infoContainer: {
    marginLeft: theme.spacing(2),
  },
  detailsContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 5,
  },
  imageContainer: {
    display: 'inline-flex',
    width: props => (props.inSidebar || props.isMobile ? 50 : 106),
    height: 'fit-content',
    flexShrink: 0,
    '&  img': {
      maxHeight: '100%',
      maxWidth: '100%',
    },
  },
  subtitle: {
    fontSize: props => props.isMobile && '0.875rem',
  },
}));

export const CourseSidebarInformation = ({
  coursesSiteCopy,
  item,
  inSidebar = false,
  isMobile,
}) => {
  const classes = useStyles({ inSidebar, isMobile });
  const imageSrc = getImageFile(item.fields);

  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        <img src={imageSrc} alt="Series" />
      </div>
      <div className={classes.infoContainer}>
        <Typography
          color="textPrimary"
          variant={inSidebar || isMobile ? 'h6' : 'h4'}
        >
          {item.fields.title}
        </Typography>
        {!inSidebar && (
          <Typography
            color="textPrimary"
            className={classes.subtitle}
            variant="body1"
          >
            {item.fields.subtitle}
          </Typography>
        )}
        <div className={classes.detailsContainer}>
          <Badge
            customClasses={classes}
            type={_get(item, 'sys.contentType.sys.id')}
          />
          <div className={classes.divider} />
          <Typography color="textPrimary" variant="overline">
            {replacePlaceholders(
              _get(coursesSiteCopy, 'pageCopy.modulesCount'),
              {
                '#count': _get(item, 'fields.modules.length'),
              },
            )}
          </Typography>
        </div>
      </div>
    </div>
  );
};
